// extracted by mini-css-extract-plugin
export default {"rootMessageContainer":"Message_rootMessageContainer__QP0fx","userMessage":"Message_userMessage__jA4e2","msgBox":"Message_msgBox__Xv4h9","sysMsgBox":"Message_sysMsgBox__25TXc"};